"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _TitleCard = _interopRequireDefault(require("01_core/components/layout/TitleCard"));
var _CButton = _interopRequireDefault(require("01_core/components/materials/CButton"));
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _CTextField = _interopRequireDefault(require("01_core/components/materials/CTextField"));
var _ResourceHtml = _interopRequireDefault(require("01_core/components/materials/ResourceHtml"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _CodeUtil = require("01_core/components/system/CodeUtil");
var _CustomRouter = require("01_core/components/system/CustomRouter");
var _APIs = require("01_core/constants/APIs");
var _CodeConsts = require("01_core/constants/CodeConsts");
var _labelConsts = require("01_core/constants/labelConsts");
var _coreConfirmActions = require("01_core/reducers/coreConfirmActions");
var _coreInfoBarActions = require("01_core/reducers/coreInfoBarActions");
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _CardContent = _interopRequireDefault(require("@mui/material/CardContent"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _kansaReportActions = require("../kansaReportActions");
var _KansaReportChart = _interopRequireDefault(require("./components/KansaReportChart"));
var _KansaReportHeader = _interopRequireDefault(require("./components/KansaReportHeader"));
var _KansaReportSummary = _interopRequireDefault(require("./components/KansaReportSummary"));
var _useRHFForm = require("01_core/validation/useRHFForm");
var _validationHelpers = require("01_core/validation/validationHelpers");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * 監査報告書登録画面
 */
function KansaReportRegister(props) {
  var _entries$kansabumonCo, _entries$kansabumonCo2, _errors$kansabumonCom;
  const {
    intl,
    callAPI,
    openInfoBar,
    openConfirm,
    setEntries,
    changeEntry,
    setRegister,
    resetRegister,
    clearEntries,
    goMain,
    goRefer,
    entries,
    info,
    targetReport,
    dispContent,
    checkDirty,
    getCodeName
    // withRouter/withCodeUtilで付与されたpropsはそのまま利用
  } = props;

  // RHF＋Yup スキーマ（監査部門コメント：任意＋最大500、trimして空は未入力扱い）
  const shape = {
    kansabumonComment: (0, _validationHelpers.optionalStringTrim)().max(500, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_LENGTH_MESSAGE
    }, {
      0: 500
    }))
  };

  // RHF 初期値
  const defaultValues = {
    kansabumonComment: (_entries$kansabumonCo = entries === null || entries === void 0 ? void 0 : entries.kansabumonComment) !== null && _entries$kansabumonCo !== void 0 ? _entries$kansabumonCo : ''
  };
  const {
    handleSubmit,
    setValue,
    formState,
    reset
  } = (0, _useRHFForm.useRHFForm)({
    defaultValues,
    shape
  });
  const {
    errors
  } = formState;

  // 初期ロード：参照データ取得
  (0, _react.useEffect)(() => {
    window.scrollTo(0, 0);
    const {
      kaishaSummary,
      kansaTgtNendo,
      hikansabumonKaishaCd,
      hikansabumonSoshikiCd
    } = targetReport;
    callAPI(_APIs.KANSA_REPORT_RP_REFER, {
      kaishaSummary,
      kansaTgtNendo,
      hikansabumonKaishaCd,
      hikansabumonSoshikiCd,
      editable: true
    }).then(response => {
      if (response.status === _APIs.STATUS.SUCCESS) {
        var _response$data$kansab, _response$data;
        props.setDirty && props.setDirty(false);
        setEntries(response.data);
        // RHFの値も同期
        reset({
          kansabumonComment: (_response$data$kansab = (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.kansabumonComment) !== null && _response$data$kansab !== void 0 ? _response$data$kansab : ''
        });
      }
    });

    // 破棄時：entriesクリア
    return () => {
      clearEntries();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [callAPI, setEntries, clearEntries, targetReport]);

  // 監査部門コメント変更：Redux＋RHFへ同期
  const onChangeComment = (0, _react.useCallback)(value => {
    changeEntry('kansabumonComment', value);
    props.setDirty && props.setDirty(true);
    setValue('kansabumonComment', value, {
      shouldValidate: true,
      shouldDirty: true
    });
  }, [changeEntry, setValue, props]);

  // 登録API呼び出し
  const registerEntries = (0, _react.useCallback)(done => {
    callAPI(_APIs.KANSA_REPORT_RP_REGISTER, _objectSpread(_objectSpread({}, entries), {}, {
      creStsCd: info.entryStsCd
    })).then(response => {
      if (response.status === _APIs.STATUS.SUCCESS) {
        props.setDirty && props.setDirty(false);
        if (done) {
          goRefer(targetReport, dispContent);
        } else {
          openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.SUCCESS, intl.formatMessage({
            id: _labelConsts.LABEL.KANSA_REPORT_TEMPORARILY_SAVED
          }));
          goMain(dispContent);
        }
      } else {
        openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, response.message);
      }
    });
  }, [callAPI, entries, info, goRefer, targetReport, dispContent, openInfoBar, intl, goMain, props]);

  // 送信（onValid）
  const onValid = (0, _react.useCallback)(() => {
    const done = info.entryStsCd === _CodeConsts.CODE.KANSA_RP_CRESTS.CODE_3;
    openConfirm(intl.formatMessage({
      id: _labelConsts.LABEL.CORE_CONFIRM
    }), /*#__PURE__*/_react.default.createElement(_ResourceHtml.default, {
      id: done ? _labelConsts.LABEL.CORE_REGISTER_CONFIRM_MESSAGE : _labelConsts.LABEL.KANSA_TEMPORARILY_SAVE_CONFIRM_MESSAGE
    }), () => registerEntries(done));
  }, [openConfirm, intl, info, registerEntries]);

  // 送信（onInvalid）
  const onInvalid = (0, _react.useCallback)(() => {
    resetRegister();
    openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_VALIDATE_MESSAGE
    }));
  }, [resetRegister, openInfoBar, intl]);
  const isDone = (entries === null || entries === void 0 ? void 0 : entries.creStsCd) === _CodeConsts.CODE.KANSA_RSLT_STS.CODE_3;

  // 戻るボタン
  const returnBtn = /*#__PURE__*/_react.default.createElement(_CButton.default, {
    negative: true,
    autoWidth: true,
    onClick: () => {
      checkDirty(() => {
        goMain(dispContent);
      });
    }
  }, intl.formatMessage({
    id: _labelConsts.LABEL.CORE_TO_RETURN_SEARCH_LIST
  }));

  // 一時保存ボタン（送信前にステータス設定）
  const temporaryBtn = /*#__PURE__*/_react.default.createElement(_CButton.default, {
    autoWidth: true,
    submit: true,
    onClick: () => {
      setRegister(_CodeConsts.CODE.KANSA_RP_CRESTS.CODE_2);
    }
  }, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_TEMPORARILY_SAVE
  }));

  // 登録ボタン（送信前にステータス設定）
  const registerBtn = /*#__PURE__*/_react.default.createElement(_CButton.default, {
    autoWidth: true,
    submit: true,
    onClick: () => {
      setRegister(_CodeConsts.CODE.KANSA_RP_CRESTS.CODE_3);
    }
  }, intl.formatMessage({
    id: _labelConsts.LABEL.CORE_REGISTER
  }));

  // ボタン生成
  const withTempButton = [returnBtn, temporaryBtn, registerBtn];
  const noTempButton = [returnBtn, registerBtn];
  return info.ready ? /*#__PURE__*/_react.default.createElement("form", {
    noValidate: true,
    onSubmit: handleSubmit(onValid, onInvalid)
  }, /*#__PURE__*/_react.default.createElement(_TitleCard.default, {
    title: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_REPORT_REGISTER
    }),
    actions: isDone ? noTempButton : withTempButton,
    fixedWidth: true
  }, /*#__PURE__*/_react.default.createElement(_CardContent.default, null, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true
  }, !(info.ready && entries) ? /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2"
  }, intl.formatMessage({
    id: _labelConsts.LABEL.CORE_NO_DATA_TO_DISPLAY
  }))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_KansaReportHeader.default, {
    entries: entries
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_KansaReportSummary.default, {
    entries: entries,
    openDetail: props.openDetail
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_KansaReportChart.default, {
    intl: intl,
    getCodeName: getCodeName,
    entries: entries
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_KANSABUMON_COMMENT
    })
  }, /*#__PURE__*/_react.default.createElement(_CTextField.default, {
    value: (_entries$kansabumonCo2 = entries === null || entries === void 0 ? void 0 : entries.kansabumonComment) !== null && _entries$kansabumonCo2 !== void 0 ? _entries$kansabumonCo2 : '',
    onChange: onChangeComment,
    multiline: true,
    rows: 10,
    maxLength: 500,
    error: !!errors.kansabumonComment,
    helperText: (_errors$kansabumonCom = errors.kansabumonComment) === null || _errors$kansabumonCom === void 0 ? void 0 : _errors$kansabumonCom.message
  })))))))) : null;
}
const mapStateToProps = state => {
  return {
    targetReport: state.kansaReport.targetReport,
    entries: state.kansaReport.creation.entries,
    info: state.kansaReport.creation,
    dispContent: state.kansaReport.containerInfo.dispContent,
    previousContent: state.kansaReport.containerInfo.previousContent
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setEntries: entries => dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.SET_RP_ENTRIES](entries)),
    changeEntry: (key, value) => {
      dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.SET_RP_ENTRY](key, value));
    },
    setRegister: value => {
      dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.SET_CREATION_REGISTER](value));
    },
    resetRegister: () => {
      dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.RESET_CREATION_REGISTER]());
    },
    openInfoBar: (type, message) => dispatch(_coreInfoBarActions.coreInfoBarActions[_coreInfoBarActions.TYPES_INFO_BAR.OPEN](type, message)),
    goMain: previousContent => dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.GO_MAIN](previousContent)),
    goRefer: (entries, previousContent) => dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.GO_REFER](entries, previousContent)),
    openConfirm: (title, message, onClickOk) => dispatch(_coreConfirmActions.coreConfirmActions[_coreConfirmActions.TYPES_CONFIRM.OPEN](title, message, onClickOk)),
    clearEntries: () => dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.CLEAR_RP_ENTRIES]()),
    setDirty: dirty => dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.SET_DIRTY](dirty))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)((0, _CodeUtil.withCodeUtil)((0, _CustomRouter.withRouter)((0, _CallAPI.withCallAPI)(KansaReportRegister)))));